import { render, staticRenderFns } from "./stockup.vue?vue&type=template&id=2b057f1c&scoped=true&"
import script from "./stockup.vue?vue&type=script&lang=js&"
export * from "./stockup.vue?vue&type=script&lang=js&"
import style0 from "./stockup.vue?vue&type=style&index=0&id=2b057f1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b057f1c",
  null
  
)

export default component.exports